import { noop } from 'underscore';
import { Ads } from './dummy-js-data-resource';
import { Ad } from './schema';

export const dummyDataSource = {
  type: 'js-data',
  entity: Ads,
  primaryKey: 'Id',
  schema: Ad,
  options: {
    entitySet: {
      toJSON: noop,
    },
  },
};
